"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DefaultErrorList = {
    addError: function (error) {
        console.warn("ERROR " + error.errorCode + ": " + error.errorMessage);
        return 'defaultErrorId';
    },
    removeError: function (errorId) {
        // no op
    },
    clearErrors: function () {
        // no op
    },
    errors: [],
};
exports.ErrorListContext = React.createContext(DefaultErrorList);
//# sourceMappingURL=ErrorListContext.js.map